import { Button } from "@themes/pollinator/ui/Button";
import {
  useUpdateActionStatus,
  isActionCompleted,
  ACTION_STATUS,
  type Action,
} from "@core/features/actions";
import { useDialog } from "@platform/store";

export type Props = {
  action: Action;
};

export function VideoUIEndQuizAction({ action }: Props) {
  const { mutate: setToInProgressUserActionStatus } = useUpdateActionStatus({
    actionId: action?.id,
    status: ACTION_STATUS.IN_PROGRESS,
    currentStatus: action?.current_status?.name,
  });

  const { openDialog } = useDialog();

  const onSurveyClick = () => {
    if (!action) {
      return;
    }

    // target_object_id is the quiz ID for meeting surveys
    const quizId = action.target_object_id;

    openDialog("quiz", {
      quizId,
      userActionId: action.id,
      actionCompleted: isActionCompleted(action),
    });

    setToInProgressUserActionStatus();
  };

  return (
    <Button onClick={onSurveyClick} variant="primary">
      Take Survey
    </Button>
  );
}

export default VideoUIEndQuizAction;
